import { Injectable } from '@angular/core';
import { DwMetaDataFormComponent, DwModalService } from '@devwareapps/devware-cap';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { DwUserEntity } from '../../../meta-data/app-meta-data.service';

/** Coordinates the profile header and its inline CAP form; CAP still owns all writes. */
@Injectable({ providedIn: 'root' })
export class ProfileInlineEditService {
    readonly userId$ = new BehaviorSubject<number>(null);
    readonly bannerAction$ = new Subject<{ userId: number; action: 'edit' | 'style' }>();
    readonly completed$ = new Subject<{ userId: number; cancelled: boolean; data?: DwUserEntity }>();
    form: DwMetaDataFormComponent;
    constructor(private modal: DwModalService) {}
    begin(userId: number): void {
        if (userId > 0 && !this.userId$.value) { this.userId$.next(userId); }
    }
    finish(userId: number, cancelled: boolean, data?: DwUserEntity): void {
        if (this.userId$.value !== userId) { return; }
        this.form = null;
        this.userId$.next(null);
        this.completed$.next({ userId, cancelled, data: cancelled ? undefined : data });
    }
    canNavigate(): Observable<boolean> {
        return this.form?.hasChanges() ? this.modal.showConfirmDialog({
            title: 'Leave profile?', message: 'You have unsaved changes. Leave without saving?',
            useConfirmDefaults: true, showConfirmDialog: true,
        }) : of(true);
    }
}
